import { createContext } from 'react';
import { RegionOption, ResolvedRegion, RegionConfig } from './models';

export interface RegionContextData {
    selectedRegion: RegionOption;
    resolvedRegion: ResolvedRegion;
    autoDetectedRegion: ResolvedRegion;
    config: RegionConfig;
    isLoading: boolean;
    setRegion: (region: RegionOption) => void;
}

export const RegionContext = createContext<RegionContextData | undefined>(
    undefined
);
